// PostHog analytics event tracking service
// All tracked events for Life Re:Scripted platform

import { getPostHog } from '../../posthog';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;

function capture(event: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  getPostHog()?.capture(event, properties);
}

// ── Page Views ──────────────────────────────────────────────

export function trackPostHogPageView(title: string, path: string) {
  capture('$pageview', {
    $current_url: path,
    title,
  });
}

// ── Auth Events ─────────────────────────────────────────────

export function trackSignupStarted() {
  capture('signup_started');
}

export function trackSignupCompleted() {
  capture('signup_completed');
}

// ── Journal Events ──────────────────────────────────────────

export function trackFirstJournalEntry() {
  capture('first_journal_entry');
}

export function trackQuickLogCompleted(mood?: number, energy?: number) {
  capture('quick_log_completed', {
    mood_score: mood,
    energy_score: energy,
  });
}

// ── Forge Events ────────────────────────────────────────────

export function trackForgeSessionStarted(tool: 'mindforge' | 'habitforge' | 'coreforge') {
  capture('forge_session_started', { tool });
}

// ── Community Events ────────────────────────────────────────

export function trackCommunityPostCreated(postType?: string) {
  capture('community_post_created', { post_type: postType });
}

export function trackVictoryWallPost() {
  capture('victory_wall_post');
}

// ── Subscription Events ─────────────────────────────────────

export function trackUpgradeClick(source?: string) {
  capture('upgrade_click', { source });
}

// ── Session Duration ────────────────────────────────────────

let sessionStart: number | null = null;

export function startSessionTimer() {
  sessionStart = Date.now();
}

export function trackSessionDuration() {
  if (!sessionStart) return;
  const durationSeconds = Math.round((Date.now() - sessionStart) / 1000);
  capture('session_duration', { duration_seconds: durationSeconds });
  sessionStart = null;
}
